import React, { lazy, useEffect, useState, useRef,Suspense  } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isMobile,
  isTablet,
  isBrowser,
  isSmartTV,
  deviceType,
  osName,
} from "react-device-detect";
import {
  getBestSellerdata,
  getHeaderdata,
  gettestimonialdata,
  getHomepagedata,
  getHomePageMainBannerdata,
  getHomePageSubBannerdata,
  getProductCountCard,
  getReadourblogsdata,
  getShopbyfinishdata,
  getVideodata,
  instgramLinks,
  starSpotting,
  getSubscriptionData,
} from "../redux/action/homeAction";
import config from "../utilities/config";
import Collections from "./Collections";
import { Link, useNavigate } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import constants from "../utilities/constants";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "../styles/styles.css";

// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Slider
import Slider from "react-slick";

// import required modules
import { Grid, Pagination, Autoplay } from "swiper/modules";

import { InstagramEmbed } from "react-social-media-embed";
import {
  formatCurrencywithamount,
  formatDate,
  urlchange,
} from "../utilities/helper";
import { getAuthModalType } from "../redux/action/authAction";
import { isEmptyArray } from "formik";
import { ismailsubscribed } from "../utilities/api";

const BannerSlider = lazy(() => import("../components/BannerSlider"));

function Home() {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const {
    homeResponseSuccess,
    homeResponseError,
    ismailsubscriptionwithoutlogin,
    homeMainBannerResponseSuccess,
    homeMainBannerResponseLoading,
    homeSubBannerResponseSuccess,
    bestSellerResponseSuccess,
    shopbyfinishCollectionResponseSuccess,
    readOurBlogsDataResponseSuccess,
    videoDataResponseSuccess,
    productsCountCardDataResponseSuccess,
    testimonialDataResponseSuccess,
    instagramLinkResponseSuccess,

    starSpottingResponseSuccess,
    subscribeTime,
  } = useSelector((state) => state.homeReducer);
  config.logGeneral &&
    console.log(
      shopbyfinishCollectionResponseSuccess,
      "shopbyfinishCollectionResponseSuccess",
      bestSellerResponseSuccess,
      "bestSellerResponseSuccess"
    );
  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  const { isemailsubscribed, isLoggedIn } = useSelector(
    (state) => state.authReducer
  );
  config.logGeneral &&
    console.log(starSpottingResponseSuccess, "===>starSpottingResponseSuccess");

  const [firstTwoItems, setFirstTwoItems] = useState(null);
  const [thirdItems, setThirdItems] = useState(null);
  const [fourthItems, setFourthItems] = useState(null);
  const [lastItems, setLastItems] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndexInsta, setActiveIndexInsta] = useState(0);
  const FIFTEEN_MINUTES = 30 * 60 * 1000;

  const bestSellerData = bestSellerResponseSuccess?.props?.cardContent || [];

  const blogs = readOurBlogsDataResponseSuccess?.props?.cardContent || [];
  config.logGeneral && console.log(blogs,"blogslength",blogs.length)
  const testimonial = testimonialDataResponseSuccess?.props?.cardContent || [];

  // config.logGeneral && console.log(firstThreeItems, "firstThreeItems");
  useEffect(() => {
    // Sub Banner
    // const firstThreeItem = homeSubBannerResponseSuccess?.props?.cardContent?.slice(0, 3) || [];
    // const lastTwoItem = homeSubBannerResponseSuccess?.props?.cardContent?.slice(3, 5) || [];
    // if (isLoggedIn) {
    //   !ismailsubscriptionwithoutlogin &&
    //     !isemailsubscribed &&
    //     dispatch(getAuthModalType(constants.Subscribe));
    // } else {
    //   !ismailsubscriptionwithoutlogin &&
    //     dispatch(getAuthModalType(constants.Subscribe));
    // }
    setFirstTwoItems(
      homeSubBannerResponseSuccess?.props?.cardContent?.slice(0, 2) || []
    );
    setThirdItems(
      homeSubBannerResponseSuccess?.props?.cardContent?.slice(2, 3) || []
    );
    setFourthItems(
      homeSubBannerResponseSuccess?.props?.cardContent?.slice(3, 4) || []
    );
    setLastItems(
      homeSubBannerResponseSuccess?.props?.cardContent?.slice(4) || []
    );
  }, [homeSubBannerResponseSuccess]);
  useEffect(() => {
    const checkAndDispatch = () => {
      config.logGeneral &&
        console.log(
          isLoggedIn,
          "isLoggedIn",
          isemailsubscribed,
          "isemailsubscribed",
          ismailsubscriptionwithoutlogin,
          "ismailsubscriptionwithoutlogin"
        );
      const shouldCheck =
        (isLoggedIn && !isemailsubscribed) ||
        (!isLoggedIn && !ismailsubscriptionwithoutlogin);

      if (shouldCheck) {
        const lastDispatch = localStorage.getItem("lastFetchTime");
        const now = Date.now();

        if (!lastDispatch || now - lastDispatch >= FIFTEEN_MINUTES) {
          dispatch(getAuthModalType(constants.Subscribe));
          localStorage.setItem("lastFetchTime", now);
        }
      }
    };

    // Check immediately on mount
    checkAndDispatch();

    // Then set an interval to keep checking every minute (or whatever frequency you prefer)
    const intervalId = setInterval(checkAndDispatch, 60000); // check every minute

    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, [dispatch, isLoggedIn, ismailsubscriptionwithoutlogin, isemailsubscribed]);

  // useEffect(() => {
  //   const MODAL_SHOW_INTERVAL = 60000 * 30; // 2 minutes in milliseconds
  //   const MODAL_STORAGE_KEY = "autoModalLastShown";

  //   // Retrieve the last shown timestamps from localStorage
  //   const lastShown = JSON.parse(localStorage.getItem(MODAL_STORAGE_KEY)) || [];

  //   // Function to check if the modal should be shown
  //   const checkAndShowModal = () => {
  //     const now = Date.now();
  //     const shouldShowModal =
  //       lastShown.filter((timestamp) => now - timestamp < MODAL_SHOW_INTERVAL)
  //         .length < 2;

  //     if (
  //       (!ismailsubscriptionwithoutlogin || !isemailsubscribed) &&
  //       shouldShowModal
  //     ) {
  //       dispatch(getAuthModalType(constants.Subscribe));
  //       lastShown.push(now);
  //       localStorage.setItem(MODAL_STORAGE_KEY, JSON.stringify(lastShown));
  //     }
  //   };

  //   // Initial check to show the modal on component mount
  //   checkAndShowModal();

  //   // Set up an interval to show the modal every 2 minutes
  //   const intervalId = setInterval(checkAndShowModal, MODAL_SHOW_INTERVAL);

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, [
  //   dispatch,
  //   ismailsubscriptionwithoutlogin,
  //   isemailsubscribed,
  //   constants.Subscribe,
  // ]);

  useEffect(() => {
    dispatch(getHeaderdata());
    dispatch(getHomepagedata());
    dispatch(getHomePageMainBannerdata());
    dispatch(getHomePageSubBannerdata());
    dispatch(getBestSellerdata());
    dispatch(getShopbyfinishdata());
    dispatch(getReadourblogsdata());
    dispatch(getVideodata());
    dispatch(getProductCountCard());
    dispatch(gettestimonialdata());
    dispatch(instgramLinks());
    dispatch(starSpotting());
  }, []);
  let sliderRef = useRef(null);
  const goToPrev = () => {
    if (sliderRef) sliderRef.slickPrev();
  };

  const goToNext = () => {
    if (sliderRef) sliderRef.slickNext();
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  const descriptionShowYouMayLike = (description) => {
    const maxLength = isMobile || isTablet ? 15 : 30;
    return description?.length > maxLength
      ? description?.slice(0, maxLength - 1) + ".."
      : description;
  };

  return !homeMainBannerResponseLoading && homeMainBannerResponseSuccess ? (
    <>
      {homeMainBannerResponseSuccess?.props?.banners && 
      <Suspense fallback={<div>Loading banners...</div>}>
      <BannerSlider
        bannerdata={homeMainBannerResponseSuccess?.props?.banners}
      />
      </Suspense>}
      <div className="text-center pt-14">
        <h1 className="font-tiemann font-semibold lg:text-2xl text-md tracking-wide pb-5">Silver Jewellery for Every Day & Special Occasion</h1>
        <h2 className="font-medium lg:text-xl text-sm tracking-normal lg:px-14 px-4 text-center leading-snug whitespace-pre-line lg:block hidden">Every piece from Stylori Silver is crafted with certified pure 925 silver, offers{"\n"}exceptional finish, lasting quality, and elegance made to shine for years to come</h2>
        <h2 className="font-medium lg:text-xl text-sm tracking-normal lg:px-14 px-4 text-center leading-snug whitespace-pre-line lg:hidden block">Every piece from Stylori Silver is crafted with certified pure 925 silver, offers exceptional finish, lasting quality, and elegance made to shine for years to come</h2>
        <p className="font-tiemann lg:pt-5 pt-3 lg:text-base text-[14px]"><i>Discover Your Perfect Piece</i></p>
      </div>
      <div className="container mx-auto">
        {/* Jewellery Quality */}
        <div className="lg:grid lg:grid-cols-12 gap-6 mt-20 mb-16 hidden">
          <div className="col-span-12 lg:col-span-3">
            <div className="border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] relative">
              <div className="absolute end-5 -top-10 right-10">
                <img
                  alt="Certified 925 Silver"
                  src={constants.DEFAULT_IMAGE + "/stylori_purity.svg"}
                  className="!w-[70px] !h-[70px]"
                />
              </div>
              <p className="text-xl font-bold text-gradient mb-2 font-tiemann">
                Certified 925 Silver
              </p>
              <p className="text-base font-light font-century text-[#222222]">
                Crafted with certified 925 sterling silver for lasting shine.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-3">
            <div className="border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] relative">
              <div className="absolute end-5 -top-10 right-10">
                <img
                  alt="Free Shipping"
                  src={constants.DEFAULT_IMAGE + "/stylori_shipping.svg"}
                  className="!w-[70px] !h-[70px]"
                />
              </div>
              <p className="text-xl font-bold text-gradient mb-2 font-tiemann">
                Free Shipping
              </p>
              <p className="text-base font-light font-century text-[#222222]">
                Pan-India free shipping on all orders.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-3">
            <div className="border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] relative">
              <div className="absolute end-5 -top-10 right-10">
                <img
                  alt="100 year of trust"
                  src={constants.DEFAULT_IMAGE + "/stylori_since.svg"}
                  className="!w-[70px] !h-[70px]"
                />
              </div>
              <p className="text-xl font-bold text-gradient mb-2 font-tiemann">
                100 year of trust
              </p>
              <p className="text-base font-light font-century text-[#222222]">
                Born from the house of NAC, made just for you.
              </p>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-3">
            <div className="border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] relative">
              <div className="absolute end-5 -top-10 right-10">
                <img
                  alt="Hypoallergenic"
                  src={constants.DEFAULT_IMAGE + "/stylori_covid.svg"}
                  className="!w-[70px] !h-[70px]"
                />
              </div>
              <p className="text-xl font-bold text-gradient mb-2 font-tiemann">
                Hypoallergenic
              </p>
              <p className="text-base font-light text-[#222222]">
                Gentle on skin, Hypoallergenic by design.
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Jewellery Quality */}

        <div className="lg:hidden lg:mt-10 mt-5 mb-5 p-5">
          <Swiper
            slidesPerView={1}
            grid={{
              rows: 1,
            }}
            spaceBetween={15}
            pagination={{
              clickable: true,
            }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            modules={[Grid, Pagination, Autoplay]}
            className="mySwiper swipper-jewel overflow-x-hidden"
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          >
            <>
              <SwiperSlide>
                <div
                  className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] !w-[320px] relative ${
                    activeIndex === 0 ? "!overflow-visible z-10" : "hidden"
                  }`}
                >
                  <div className="absolute end-5 -top-6 right-10">
                    <img
                      alt="Certified 925 Silver"
                      src={constants.DEFAULT_IMAGE + "/stylori_purity.svg"}
                      className="!w-[52px] !h-[52px] object-cover"
                    />
                  </div>
                  <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                    Certified 925 Silver
                  </p>
                  <p className="text-base font-light font-century text-left">
                    Crafted with certified 925 sterling silver for lasting
                    shine.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide className="flex-col relative">
                <div
                  className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] !w-[320px] relative ${
                    activeIndex === 1 ? "!overflow-visible z-10" : "hidden z-0"
                  }`}
                >
                  <div className="absolute end-5 -top-6 right-10 ">
                    {/* <img
                      alt="Certified img"
                      src="./images/Certified.svg"
                      className="!w-[52px] !h-[52px] object-cover z-50"
                    /> */}
                    <img
                      alt="Free Shipping"
                      src={constants.DEFAULT_IMAGE + "/stylori_shipping.svg"}
                      className="!w-[52px] !h-[52px] object-cover"
                    />
                  </div>
                  <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                    Free Shipping
                  </p>
                  <p className="text-base font-light font-century text-left">
                    Pan-India free shipping on all orders.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide className="flex-col relative">
                <div
                  className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] !w-[320px] relative ${
                    activeIndex === 2 ? "!overflow-visible z-10" : "hidden z-0"
                  }`}
                >
                  <div className="absolute end-5 -top-6 right-10">
                    <img
                      alt="100 year of trust"
                      src={constants.DEFAULT_IMAGE + "/stylori_since.svg"}
                      className="!w-[52px] !h-[52px] object-cover"
                    />
                  </div>
                  <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                    100 year of trust
                  </p>
                  <p className="text-base font-light font-century text-left">
                    Born from the house of NAC, made just for you.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide className="flex-col relative">
                <div
                  className={`border border-[#D2D2D2] p-5 rounded-tr-[30px] rounded-bl-[30px] !h-[125px] !w-[320px] relative ${
                    activeIndex === 3 ? "!overflow-visible z-10" : "hidden z-0"
                  }`}
                >
                  <div className="absolute end-5 -top-6 right-10">
                    <img
                      alt="Hypoallergenic"
                      src={constants.DEFAULT_IMAGE + "/stylori_covid.svg"}
                      className="!w-[52px] !h-[52px] object-cover"
                    />
                  </div>
                  <p className="text-xl font-bold text-gradient mb-2 font-tiemann text-left">
                    Hypoallergenic
                  </p>
                  <p className="text-base font-light text-left">
                    Gentle on skin, Hypoallergenic by design.
                  </p>
                </div>
              </SwiperSlide>
            </>
          </Swiper>
        </div>

        {/* Sub-banner Section */}
        <div className="mt-10 hidden lg:block">
          {/* First Row with 2 items */}
          <div className="grid grid-cols-2 gap-4">
            {firstTwoItems !== null &&
              firstTwoItems.length > 0 &&
              firstTwoItems?.map((subIndex, index) => (
                <div key={index} className="relative group overflow-hidden">
                  <div className="relative">
                    <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                      {" "}
                      <img
                        src={subIndex.image}
                        alt="Default"
                        className="w-full"
                      />
                      <p
                        className="pl-3 py-3 mb-8 absolute bottom-0 right-0 text-right pr-5
                          opacity-0 translate-x-full group-hover:translate-x-0 group-hover:opacity-100 
                          transition-transform duration-500 ease-in-out text-white font-tiemann font-medium text-3xl bg-gradient-to-r from-[#09090900] to-[#000000] uppercase"
                      >
                        {subIndex.text} <br></br>
                        <span className="font-light text-2xl capitalize">
                          Collection
                        </span>
                      </p>
                    </Link>
                  </div>
                </div>
              ))}
          </div>

          {/* Third Image */}
          <div className="mt-5">
            {thirdItems !== null &&
              thirdItems.length > 0 &&
              thirdItems?.map((subIndex, index) => (
                <div key={index} className="relative group overflow-hidden">
                  <div className="relative">
                    <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                      {" "}
                      <img
                        src={subIndex.image}
                        alt="Default"
                        className="w-full"
                      />
                      <p
                        className="pl-3 py-3 mb-8 absolute bottom-0 right-0 text-right pr-5
                          opacity-0 translate-x-full group-hover:translate-x-0 group-hover:opacity-100 
                          transition-transform duration-500 ease-in-out text-white font-tiemann font-medium text-3xl bg-gradient-to-r from-[#09090900] to-[#000000] uppercase"
                      >
                        {subIndex.text} <br></br>
                        <span className="font-light text-2xl capitalize">
                          Collection
                        </span>
                      </p>
                    </Link>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Mobile Subbanner Section */}
        <div className="mt-5 p-5 sm:hidden">
          {/* First Row with 2 items */}
          <div className="grid grid-cols-1 gap-4">
            {firstTwoItems !== null &&
              firstTwoItems.length > 0 &&
              firstTwoItems?.map((subIndex, index) => (
                <div key={index} className="relative group">
                  <div className="relative">
                    <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                      {" "}
                      <img
                        src={subIndex.image}
                        alt="Default"
                        className="w-full"
                      />
                      <p className="pl-3 py-1 mb-6 absolute bottom-0 right-0 text-right pr-5 text-white font-tiemann font-medium text-sm bg-gradient-to-r from-[#09090900] to-[#000000] uppercase">
                        {subIndex.text} <br></br>
                        <span className="font-light text-xs capitalize">
                          Collection
                        </span>
                      </p>
                    </Link>
                  </div>
                </div>
              ))}
          </div>

          {/* Third Image */}
          <div className="mt-5">
            {thirdItems !== null &&
              thirdItems.length > 0 &&
              thirdItems?.map((subIndex, index) => (
                <div key={index} className="relative group overflow-hidden">
                  <div className="relative">
                    <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                      {" "}
                      <img
                        src={subIndex.image}
                        alt="Default"
                        className="w-full"
                      />
                      <p className="pl-3 py-1 mb-6 absolute bottom-0 right-0 text-right pr-5 text-white font-tiemann font-medium text-sm bg-gradient-to-r from-[#09090900] to-[#000000] uppercase">
                        {subIndex.text} <br></br>
                        <span className="font-light text-xs capitalize">
                          Collection
                        </span>
                      </p>
                    </Link>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/*  */}
        {/* <div className="bg-[#EFEBE8] lg:flex lg:items-center justify-center gap-10 p-3 mt-5 mb-5 text-center">
          <p className="text-base font-bold font-tiemann text-[#887127] uppercase lg:mb-0 mb-2">
            Checkout our recent collections
          </p>
          <Link to="silver-special+offer+sale-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0">
            <button className="border border-[#887127] text-lg font-medium text-black px-4 py-1">
              Shop now
            </button>
          </Link>
        </div> */}

        {/* Highend Jewellery Design */}
        <>
          <Swiper
            slidesPerView={1}
            grid={{
              rows: 1,
            }}
            spaceBetween={15}
            pagination={{
              clickable: true,
            }}
            // autoplay={{
            //   delay: 3000,
            //   disableOnInteraction: false,
            // }}
            modules={[Pagination, Autoplay]}
            className="mySwiper swipper-high overflow-x:hidden; mt-5"
          >
            {constants?.vow?.map((vowproduct) => (
              <SwiperSlide key={vowproduct?.id}>
                <div className="lg:grid lg:grid-cols-2 items-center lg:mt-20 mt-7">
                  <div className="col-span-1 mb-4 lg:text-left text-center">
                    <p className="text-black font-medium lg:text-2xl text-sm pb-3 lg:pb-0">
                      {vowproduct?.text1}
                    </p>
                    <h2 className="lg:text-[65px] text-[23px] font-tiemann font-bold text-black uppercase lg:leading-none leading-[1.3] lg:tracking-normal tracking-wider">
                      {vowproduct?.text2} {vowproduct?.text4} <br />
                      <span className="lg:text-[65px] text-[23px] font-tiemann font-bold text-[#BD8C54] uppercase lg:leading-none leading-[1.3] lg:tracking-normal tracking-wider">
                        {vowproduct?.text3} {vowproduct?.text5}
                      </span>
                    </h2>
 
                    <Link to={`${constants.ADDITIONAL_PATH}${vowproduct.url}`} className="lg:block hidden">
                      <button className="border border-[#BD8C54] text-black font-medium text-2xl px-7 py-1 lg:mt-6 mt-3">
                        Shop now
                      </button>
                    </Link>
                  </div>
                  <div className="col-span-1 lg:p-0 p-5">
                    <img
                      src={`${constants.DEFAULT_IMAGE}${vowproduct.image}`}
                      className="rounded-tl-[60px]"
                      alt={`Vow ${vowproduct?.text1}`}
                    />
                  </div>
                  <Link to={`${constants.ADDITIONAL_PATH}${vowproduct.url}`} className="lg:hidden block">
                      <button className="border border-[#BD8C54] text-black font-medium text-2xl px-7 py-1 lg:mt-6 mt-3">
                        Shop now
                      </button>
                    </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
 
        </>

        {/* newsetup */}
        <div className="lg:p-0 p-5 mt-10">
          {!isEmptyArray(starSpottingResponseSuccess?.props?.banners) && (
            <div className="flex items-center justify-center lg:mb-7 mb-4">
              <div className="flex-grow border-t border-[#6D6E71] hidden lg:block"></div>
              <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-2xl mb-2 lg:mb-0 capitalize">
                {starSpottingResponseSuccess?.component}
              </h2>
              <div className="flex-grow border-t border-[#6D6E71] hidden lg:block"></div>
            </div>
          )}
          {!isEmptyArray(starSpottingResponseSuccess?.props?.banners) &&
            starSpottingResponseSuccess?.props?.banners?.map(
              (subIndex, index) => (
                <div
                  key={index}
                  className="cursor-pointer"
                  onClick={() =>
                    navigation(constants.ADDITIONAL_PATH + subIndex?.url)
                  }
                >
                  <div className="relative">
                    {/* <Link to={constants.ADDITIONAL_PATH + subIndex.url}> */}
                    <img
                      src={subIndex?.mobile}
                      alt="Starspotting"
                      className="w-full h-full block lg:hidden object-cover"
                    />
                    <img
                      src={subIndex?.web}
                      alt="Starspotting"
                      className="w-full h-full  hidden lg:block object-cover"
                    />
                    {/* </Link> */}
                    {/* <h3 className="absolute lg:top-1/4 bottom-[68px] font-bold lg:text-[64px] leading-snug left-5 text-xl font-tiemann text-white lg:left-36 lg:w-1/3 w-[60%] capitalize">
                    Exploring The Beauty of Adornments
                  </h3>
                  <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                    <button className="bg-customGreen text-white absolute bottom-6 lg:bottom-44 lg:left-36 left-5 font-medium lg:text-2xl text-sm lg:px-14 lg:py-1 px-4 py-1">
                      Shop now
                    </button>
                  </Link> */}
                  </div>
                </div>
              )
            )}
        </div>
        {/* Best Seller */}
        {homeResponseSuccess?.length === constants?.CDN_HOME && (
          <div className="container mx-auto lg:mt-10 mt-5">
            <div className="flex items-center justify-center">
              <div className="flex-grow border-t border-[#6D6E71] hidden lg:block"></div>
              <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-2xl flex items-center justify-center lg:mb-5 mb-4">
                {homeResponseSuccess &&
                  homeResponseSuccess[constants?.bestSeller_title]?.props
                    ?.title_Text}
              </h2>
              <div className="flex-grow border-t border-[#6D6E71] hidden lg:block"></div>
            </div>
            <div className="grid lg:grid-cols-4 grid-cols-2 gap-2 p-5 lg:p-0">
              {bestSellerData !== null &&
                bestSellerData.length > 0 &&
                bestSellerData?.map((bestseller, index) => (
                  <div key={index} className="">
                    <div
                      onClick={() => urlchange(bestseller.url)}
                      className="cursor-pointer"
                    >
                      {/* <Link to={bestseller.url}>
                        <img
                          src={bestseller.image}
                          alt="Default"
                          className="mb-3"
                        />
                      </Link> */}
                      <img
                        src={bestseller.image}
                        alt="Default"
                        className="mb-2"
                      />

                      <h3 className="text-base leading-5 font-medium text-center mt-1">
                        {descriptionShowYouMayLike(bestseller?.bottomText)}
                      </h3>
                      <p className="text-[#676767] text-center font-medium text-sm">
                        {formatCurrencywithamount(
                          bestseller.price,
                          selectedcountrySuccess
                            ? selectedcountrySuccess?.currencyAlias
                              ? selectedcountrySuccess?.currencyAlias
                              : ""
                            : "INR",
                          `en-${selectedcountrySuccess?.iso || "IN"}`,
                          dailyMetalPriceSuccess?.data?.allMasterCountries
                            ?.nodes
                        )}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
            <div className=" flex flex-col justify-center items-center">
              <Link
                to={
                  constants.ADDITIONAL_PATH +
                  "/silver-jewellery?sort=Best%20Seller&startprice=0&endprice=0"
                }
                className="flex justify-center mt-6 w-full"
              >
                <button className="bg-customGreen text-white text-2xl font-medium px-6 py-2 btn-transition">
                  View All
                </button>
              </Link>
            </div>
          </div>
        )}

        {/* Gold Pendant, etc., Collections */}
        {/* <div className="lg:grid lg:grid-cols-4 gap-5 mt-7 hidden relative z-0">
          {productsCountCardDataResponseSuccess?.length > 0 &&
            productsCountCardDataResponseSuccess.map((product, index) => (
              <div
                key={index}
                className="border border-[#E6E6E6] rounded-xl pl-6 py-6 relative group overflow-hidden"
              >
                <div
                  className="absolute inset-0 bg-gradient-to-t from-[#FFF7E7] to-[#ffffff] 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out z-0"
                ></div>

                <div className="relative z-10">
                  <img
                    src={product.image}
                    alt="Default"
                    className="p-3 rounded-lg mb-8 transition-opacity duration-300 ease-in-out 
                        bg-customGreen"
                  />                  
                  <img
                    src={product.hoverimg}
                    alt="On Hover"
                    className="pl-3 py-3 rounded-lg mb-8 absolute top-0 right-0 w-32
                    opacity-0 translate-x-full group-hover:translate-x-0 group-hover:opacity-100 
                    transition-transform duration-700 ease-in-out"
                  />

                  <h3 className="text-[#151515] font-tiemann font-bold text-[28px]">
                    {product.title}
                  </h3>

                  <p className="font-light text-xl text-[#151515]">
                    {product.product_count} Products
                  </p>
                </div>
              </div>
            ))}
        </div> */}

        {/* Mobile Gold Pendant, etc., Collections */}

        {/* <div className="lg:hidden block mt-7 p-5">
          <Swiper
            slidesPerView={1.5}
            grid={{
              rows: 1,
            }}
            spaceBetween={10}
            loop={true}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false, 
              pauseOnMouseEnter: true,
            }}
            modules={[Grid, Pagination, Autoplay]}
            className="mySwiper"
          >
            {productsCountCardDataResponseSuccess?.length > 0 &&
              productsCountCardDataResponseSuccess.map((product, index) => (
                <SwiperSlide key={index}>
                  <div
                    key={index}
                    className="border border-[#E6E6E6] rounded-xl pl-6 py-6 relative group overflow-hidden w-full"
                  >
                    <div
                      className="absolute inset-0 bg-gradient-to-t from-[#FFF7E7] to-[#ffffff] 
                        opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out z-0"
                    ></div>

                    <div className="relative z-10">
                      <img
                        src={product.image}
                        alt="Default"
                        className="p-3 rounded-lg mb-8 transition-opacity duration-300 ease-in-out 
                          bg-customGreen main-img"
                      />                      
                      <img
                        src={product.hoverimg}
                        alt="On Hover"
                        className="rounded-lg absolute bottom-0 right-0
                          opacity-0 translate-x-full group-hover:translate-x-0 group-hover:opacity-100 
                          transition-transform duration-300 ease-in-out hover-img"
                      />

                      <h3 className="text-[#151515] font-tiemann font-bold lg:text-[28px] text-lg text-left">
                        {product.title}
                      </h3>

                      <p className="font-light lg:text-xl text-[13px] text-[#151515] text-left">
                        {product.product_count} Products
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div> */}

        {/* Navarathna Collections */}
        {homeResponseSuccess?.length === constants?.CDN_HOME &&
          shopbyfinishCollectionResponseSuccess !== null && (
            <div className="lg:mb-10 mb-5 lg:mt-10 mt-5 lg:p-0 p-5">
              <div className="flex items-center justify-center lg:mb-5 mb-4">
                <div className="flex-grow border-t border-[#6D6E71] hidden lg:block"></div>
                <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-2xl mb-2 lg:mb-0">
                  {homeResponseSuccess &&
                    homeResponseSuccess[constants?.ShopbyFinish_title]?.props
                      ?.title_Text}
                </h2>
                <div className="flex-grow border-t border-[#6D6E71] hidden lg:block"></div>
              </div>
              {
                <Collections
                  // youMayLike_responseSuccess={youMayLike_responseSuccess}
                  bestseller={shopbyfinishCollectionResponseSuccess}
                />
              }
            </div>
          )}
      </div>

      {/*  */}
      {/* <div className="lg:p-0 p-5" style={{border:"3px solid pink"}}>
        {fourthItems !== null &&
          fourthItems.length > 0 &&
          fourthItems?.map((subIndex, index) => (
            <div key={index} className="">
              <div className="relative" >
                <img
                  src={subIndex.image}
                  alt="Default"
                  className="w-full lg:h-full h-[250px] object-cover"
                />
                <div className="border border-[#ffffff] absolute lg:top-10 top-4 lg:bottom-10 lg:left-9 left-3 lg:w-[96%] w-11/12 lg:h-[86%] h-[87%]">
                  <p className="text-white absolute lg:top-10 lg:right-40 right-4 top-4 font-tiemann font-bold lg:text-4xl text-sm">
                    {subIndex.text}
                  </p>
                  <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                    <button className="border border-[#ffffff] text-white absolute lg:top-28 lg:right-40 right-4 top-12 font-medium lg:text-2xl text-sm lg:px-14 lg:py-1 px-4 py-1">
                      Shop now
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </div> */}
      <div className="lg:p-0 py-5">
        {fourthItems?.length > 0 &&
          fourthItems?.map((subIndex, index) => {
            const hasText = subIndex?.text && subIndex?.text?.trim() !== "";
            const targetUrl = constants.ADDITIONAL_PATH + subIndex.url;

            const content = (
              <div className="relative">
                <img
                  src={subIndex.image}
                  alt="Default"
                  className="w-full lg:h-full"
                />

                <div className="border border-[#ffffff] absolute lg:top-10 top-2 lg:bottom-10 lg:left-9 left-3 lg:w-[96%] w-11/12 lg:h-[86%] h-[85%]">
                  {hasText && (
                    <p className="text-white absolute lg:top-10 lg:right-40 right-4 top-4 font-tiemann font-bold lg:text-4xl text-sm">
                      {subIndex.text}
                    </p>
                  )}

                  {hasText && (
                    <Link to={targetUrl}>
                      <button className="border border-[#ffffff] text-white absolute lg:top-28 lg:right-40 right-4 top-12 font-medium lg:text-2xl text-sm lg:px-14 lg:py-1 px-4 py-1">
                        Shop now
                      </button>
                    </Link>
                  )}
                </div>
              </div>
            );

            return (
              <div key={index}>
                {hasText ? content : <Link to={targetUrl}>{content}</Link>}
              </div>
            );
          })}
      </div>

      {/* Beauty of Adornments */}
      <div className="container mx-auto items-center my-1 grid grid-cols-1 gap-4 lg:grid-cols-2 lg:[&>*:nth-child(1)]:order-1 lg:[&>*:nth-child(2)]:order-2 [&>*:nth-child(1)]:order-1 [&>*:nth-child(1)]:order-2 p-5">
        <div className="col-span-1">
          <img
            src={constants.DEFAULT_IMAGE + "/jewellery-xday.jpeg"}
            className="w-[636px]"
          />
        </div>
        <div className="col-span-1">
          <h2 className="lg:text-4xl text-2xl lg:w-auto font-tiemann font-bold text-[#1A1A1A] leading-[1] lg:text-left text-center capitalize">
            Jewellery For Days That End in Y
          </h2>
          <p className="text-[#636363] font-medium lg:text-xl text-sm mt-6 text-center lg:text-left">
            Our everyday, lightweight jewellery is made to match your mood and
            every outfit in your wardrobe
          </p>
          <Link
            to={
              constants.ADDITIONAL_PATH +
              "/silver-jewellery-everyday?sort=New%20to%20Stylori&startprice=0&endprice=0"
            }
            className="flex items-center justify-center lg:justify-start"
          >
            <button className=" text-[#1A1A1A] font-tiemann font-bold lg:text-[28px] text-[17px] lg:mt-6 mt-3 gap-2 flex items-center">
              Shop Now{" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="rotate-180"
              >
                <path
                  d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                  fill="black"
                />
              </svg>
            </button>
          </Link>
          {/* <div className="flex lg:gap-7 gap-3 lg:mt-7 mt-4 lg:mb-0 mb-3 justify-between">
            <div className="border border-[#D3D3D3] rounded-full flex items-center gap-1 lg:px-3 lg:py-2 px-[6px] py-1">
              <svg
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="responsive-svg"
              >
                <rect
                  width="42"
                  height="42"
                  rx="21"
                  fill="url(#paint0_linear_1609_5633)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1609_5633"
                    x1="0"
                    y1="21.0002"
                    x2="42"
                    y2="21.0002"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ABABAB" />
                    <stop offset="0.2521" stop-color="#EDEDED" />
                    <stop offset="0.5091" stop-color="#AFAFAF" />
                    <stop offset="0.7906" stop-color="#D5D5D5" />
                    <stop offset="1" stop-color="#A7A7A7" />
                  </linearGradient>
                </defs>
              </svg>
              <p className="font-tiemann lg:text-2xl text-sm font-bold">
                Pure Silver
              </p>
            </div>
            <div className="border border-[#D3D3D3] rounded-full flex items-center gap-1 lg:px-3 lg:py-2 px-[6px] py-1">
              <svg
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="responsive-svg"
              >
                <rect
                  width="42"
                  height="42"
                  rx="21"
                  fill="url(#paint0_linear_1609_5633)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1609_5633"
                    x1="0"
                    y1="21.0002"
                    x2="42"
                    y2="21.0002"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ABABAB" />
                    <stop offset="0.2521" stop-color="#EDEDED" />
                    <stop offset="0.5091" stop-color="#AFAFAF" />
                    <stop offset="0.7906" stop-color="#D5D5D5" />
                    <stop offset="1" stop-color="#A7A7A7" />
                  </linearGradient>
                </defs>
              </svg>
              <p className="font-tiemann lg:text-2xl text-sm font-bold">
                Pure Elegance
              </p>
            </div>
            <div className="border border-[#D3D3D3] rounded-full flex items-center gap-1 lg:px-3 lg:py-2 px-[6px] py-1">
              <svg
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="responsive-svg"
              >
                <rect
                  width="42"
                  height="42"
                  rx="21"
                  fill="url(#paint0_linear_1609_5633)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1609_5633"
                    x1="0"
                    y1="21.0002"
                    x2="42"
                    y2="21.0002"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#ABABAB" />
                    <stop offset="0.2521" stop-color="#EDEDED" />
                    <stop offset="0.5091" stop-color="#AFAFAF" />
                    <stop offset="0.7906" stop-color="#D5D5D5" />
                    <stop offset="1" stop-color="#A7A7A7" />
                  </linearGradient>
                </defs>
              </svg>
              <p className="font-tiemann lg:text-2xl text-sm font-bold">
                Bridal Silver
              </p>
            </div>
          </div> */}
        </div>
      </div>

      {/* <div className="lg:p-0 p-5">
        {lastItems !== null &&
          lastItems.length > 0 &&
          lastItems?.map((subIndex, index) => (
            <div key={index} className="">
              <div className="relative">
                
                <img
                  src={subIndex.image}
                  alt="Default"
                  className="w-full lg:h-full h-[200px] object-cover"
                />
                
                <h3 className="absolute lg:top-1/4 bottom-[68px] font-bold lg:text-[64px] leading-snug left-5 text-xl font-tiemann text-white lg:left-36 lg:w-1/3 w-[60%] capitalize">
                  Exploring The Beauty of Adornments
                </h3>
                <Link to={constants.ADDITIONAL_PATH + subIndex.url}>
                  <button className="bg-customGreen text-white absolute bottom-6 lg:bottom-44 lg:left-36 left-5 font-medium lg:text-2xl text-sm lg:px-14 lg:py-1 px-4 py-1">
                    Shop now
                  </button>
                </Link>
              </div>
            </div>
          ))}
      </div> */}

      {/* Blogs */}
      <div className="hidden lg:block">
  <div className="text-center lg:mt-0 mt-5">
    <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-[24px] lg:mb-10 mb-5">
      Read our Blogs
    </h2>
  </div>

  <div className="container mx-auto">
    <Swiper
        slidesPerView={3}
        grid={{ rows: 1 }}
        spaceBetween={30}
        loop={true}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 0 },   // Mobile
          768: { slidesPerView: 2, spaceBetween: 10 },   // Tablet
          1024: { slidesPerView: 2, spaceBetween: 20 },  // Desktop
          1440: { slidesPerView: 3, spaceBetween: 20 },  // Large screens
        }}
        modules={[Grid, Pagination, Autoplay]}
        className="mySwiper"
      >
      {blogs?.length > 0 &&
        blogs.map((blog, index) => (
          <SwiperSlide key={index}>
            <div
              onClick={() =>
                navigation(constants.ADDITIONAL_PATH + `/Blog/${blog.heading}`)
              }
              className="cursor-pointer"
            >
              <img src={blog.image} alt="Default" className="w-full" />
              <p className="text-black font-semibold text-[22px] truncate mt-4">
                {blog.heading}
              </p>
              <p className="text-[#676767] font-medium text-xl">
                {formatDate(blog.date, "Month DD, YYYY")}
              </p>
            </div>
            
          </SwiperSlide>
        ))}
    </Swiper>
  </div>
</div>


      {/* Blogs Mobile */}
      <div className="lg:hidden block p-5">
        <div className="text-center lg:mt-0">
          <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-[24px] lg:mb-10 mb-5">
            Read our Blogs{" "}
          </h2>
        </div>
        <Swiper
          slidesPerView={1}
          grid={{
            rows: 1,
          }}
          spaceBetween={10}
          loop={true} // Enable loop mode
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false, // Keeps autoplay running after user interaction
            pauseOnMouseEnter: true,
          }}
          modules={[Grid, Pagination, Autoplay]}
          className="mySwiper pagination-none"
        >
          {blogs?.length > 0 &&
        blogs.map((blog, index) => (
          <SwiperSlide key={index}>
            <div
              onClick={() =>
                navigation(constants.ADDITIONAL_PATH + `/Blog/${blog.heading}`)
              }
              className="cursor-pointer"
            >
              <img src={blog.image} alt="Default" className="w-full" />
              <p className="text-black font-semibold text-[22px] lg:truncate mt-4">
                {blog.heading}
              </p>
              <p className="text-[#676767] font-medium text-xl">
                {formatDate(blog.date, "Month DD, YYYY")}
              </p>
            </div>
            
          </SwiperSlide>
        ))}
    </Swiper>
      </div>

      {/* Testimonials */}
      <div className="container mx-auto lg:mb-10 mb-0">
        <div className="text-center lg:mt-10 mt-5">
          <p className="text-[#1A1A1A] font-medium text-lg">Testimonial</p>
          <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-[24px] mb-3">
            What our Customer Say
          </h2>
        </div>
        <div className="hidden lg:block">
          <Swiper
            slidesPerView={4}
            grid={{
              rows: 1,
            }}
            spaceBetween={0}
            loop={true} // Enable loop mode
            autoplay={{
              delay: 2000,
              disableOnInteraction: false, // Keeps autoplay running after user interaction
              pauseOnMouseEnter: true,
            }}
            modules={[Grid, Autoplay]}
            className="mySwiper"
          >
            {testimonial !== null &&
              testimonial.length > 0 &&
              testimonial?.map((testimonial, index) => (
                <>
                  <SwiperSlide key={index} className="flex-col relative group">
                    <div className="">
                      <img src={constants.DEFAULT_IMAGE + "/testimonial.jpg"} />
                      <div className="absolute inset-5 flex flex-col items-center justify-center text-center px-4">
                        <p className="text-[#1A1A1A] font-medium text-xl line-clamp-4 relative cursor-pointer" title={testimonial.text}>
                          {testimonial.text}
                        </p>
                        <p className="text-customGreen font-semibold text-[25px] pt-5">
                          {testimonial.writer}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                </>
              ))}
          </Swiper>
        </div>

        {/* Mobile Testimonial */}
        <div className="lg:hidden block p-3">
          <Swiper
            slidesPerView={1.2}
            grid={{
              rows: 1,
            }}
            spaceBetween={0}
            loop={false} // Enable loop mode
            autoplay={{
              delay: 2000,
              disableOnInteraction: false, // Keeps autoplay running after user interaction
              pauseOnMouseEnter: true,
            }}
            modules={[Grid, Autoplay]}
            className="mySwiper"
          >
            {testimonial !== null &&
              testimonial.length > 0 &&
              testimonial?.map((testimonial, index) => (
                <>
                  <SwiperSlide key={index} className="flex-col relative">
                    <div className="">
                      <img src={constants.DEFAULT_IMAGE + "/testimonial.jpg"} />
                      <div className="absolute lg:top-16 top-20 lg:p-10 p-5 lg:left-auto lg:right-auto left-[2%] right-[4%]">
                        <p className="text-[#1A1A1A] font-medium lg:text-xl text-base leading-snug">
                          {testimonial.text}
                        </p>
                        <p className="text-customGreen font-semibold lg:text-[25px] text-base lg:pt-5 pt-2">
                          {testimonial.writer}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                </>
              ))}
          </Swiper>
        </div>
      </div>

      {/* Instagram */}
      {Array.isArray(instagramLinkResponseSuccess?.instagramDatas) &&
        instagramLinkResponseSuccess?.instagramDatas?.length > 0 &&
        instagramLinkResponseSuccess?.props?.title_Text !== "" && (
          <div className="container mx-auto mb-10 p-5 lg:p-0">
            <div className="text-center lg:mt-10 mt-0 lg:mb-10 mb-4">
              <h2 className="px-3 text-[#1A1A1A] font-tiemann font-normal lg:text-[40px] text-[24px] mb-3">
                {instagramLinkResponseSuccess?.props?.title_Text}
              </h2>
              <p className="text-[#1A1A1A] font-medium lg:text-lg text-base leading-4">
                {/* Tag us on Instagram on one of our gorgeous pieces to get
                featured on our page */}
                {instagramLinkResponseSuccess?.props?.sub_Text}
                {}
              </p>
            </div>
            <div className="hidden lg:block">
              <Swiper
                slidesPerView={4}
                spaceBetween={50}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false, // Keeps autoplay running after user interaction
                  pauseOnMouseEnter: true,
                }}
                modules={[Grid, Autoplay]}
                className="mySwiper flex flex-row "
              >
                {instagramLinkResponseSuccess !== null &&
                  instagramLinkResponseSuccess?.instagramDatas.length > 0 &&
                  instagramLinkResponseSuccess?.instagramDatas?.map(
                    (link, index) => (
                      <SwiperSlide
                        key={index}
                        className="flex justify-center items-center insta"
                      >
                        <div id="instagram" nav="scroll" className="instagram">
                          {link.url && (
                            <blockquote
                              className="instagram-media m-0 min-w-0"
                              cite={link.url}
                            >
                              <InstagramEmbed
                                url={link.url}
                                frame={window}
                                className="m-0 min-w-0"
                              />
                            </blockquote>
                          )}
                        </div>
                      </SwiperSlide>
                    )
                  )}
              </Swiper>
            </div>

            {/* Instagram Mobile */}
            <div className="lg:hidden block relative">
              <Swiper
                slidesPerView={1}
                spaceBetween={2}
                pagination={{
                  el: ".custom-swiper-pagination",
                  clickable: true,
                }}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                modules={[Grid, Pagination, Autoplay]}
                className="insta-swiper"
                onSlideChange={(swiper) =>
                  setActiveIndexInsta(swiper.activeIndex)
                }
              >
                {instagramLinkResponseSuccess?.instagramDatas?.map(
                  (link, index) => (
                    <SwiperSlide key={index} className="!w-full">
                      <div
                        id="instagram"
                        nav="scroll"
                        className="instagram w-full rounded-tr-[30px] rounded-bl-[30px]"
                      >
                        {link.url && (
                          <blockquote
                            className="instagram-media m-0 min-w-0"
                            cite={link.url}
                          >
                            <InstagramEmbed
                              url={link.url}
                              frame={window}
                              maxWidth="320px"
                              className="m-0 min-w-0"
                            />
                          </blockquote>
                        )}
                      </div>
                    </SwiperSlide>
                  )
                )}
              </Swiper>

              {/* 👇 Custom Pagination Container placed BELOW Swiper */}
              <div className="custom-swiper-pagination mt-4 flex justify-center" />
            </div>
          </div>
        )}
    </>
  ) : (
    <div className="text-center py-6 flex flex-col items-center">
      {/* SVG Image from Path */}
      <img
        src={constants.DEFAULT_IMAGE + "/loaderimagesilver.gif"}
        alt="loading logo"
        className="w-120 h-120"
      />
    </div>
  );
}

export default Home;
